/**
 * still. facet sidebar enhancements.
 *
 * The base AJAX submission + URL state is handled by Shopify's existing
 * <facet-filters-form> + facets.js (which the section still loads). This
 * file ONLY adds three layered behaviors that the base lacks:
 *
 *   1. Search-within-group — type in the input above any group with ≥12
 *      values, hide rows that don't match.
 *   2. Group state persistence — remember which <details> were opened
 *      across navigation so the layout doesn't reset on every page load.
 *   3. Mobile drawer toggle — open/close the sidebar drawer on small
 *      screens.
 *
 * Vanilla JS, no dependencies. Runs once at DOMContentLoaded.
 */
(function () {
  "use strict";

  const STORAGE_KEY = "still-facets-open-groups";

  /* ─── 1. Search-within-group ────────────────────────────────── */
  function wireSearchInputs() {
    document.querySelectorAll(".js-still-facets-search").forEach(function (input) {
      const groupKey = input.dataset.group;
      const list = input.closest(".still-facets__group-body")
        ?.querySelector(".still-facets__values");
      if (!list) return;

      input.addEventListener("input", function () {
        const q = input.value.trim().toLowerCase();
        list.querySelectorAll(".js-still-facets-row").forEach(function (row) {
          const label = row.dataset.rowLabel || "";
          if (!q || label.includes(q)) {
            row.classList.remove("is-hidden");
          } else {
            row.classList.add("is-hidden");
          }
        });
      });
    });
  }

  /* ─── 2. Group state persistence ────────────────────────────── */
  function loadOpenGroups() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? new Set(JSON.parse(raw)) : null;
    } catch (e) {
      return null;
    }
  }
  function saveOpenGroups(set) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
    } catch (e) {
      /* private mode / quota — silently skip */
    }
  }
  function wireGroupPersistence() {
    const persisted = loadOpenGroups();
    const groups = document.querySelectorAll(".js-still-facets-group");
    if (!groups.length) return;

    // Apply saved state (only when persisted set exists; first visit
    // honors the Liquid-rendered default-open state).
    if (persisted) {
      groups.forEach(function (g) {
        const key = g.dataset.groupKey;
        if (!key) return;
        if (persisted.has(key)) {
          g.setAttribute("open", "");
        } else if (!g.querySelector(".still-facets__group-active")) {
          // Only force-close if no active filter (we don't want to hide
          // the active filter's group from the user).
          g.removeAttribute("open");
        }
      });
    }

    // Listen for toggles + persist
    groups.forEach(function (g) {
      g.addEventListener("toggle", function () {
        const key = g.dataset.groupKey;
        if (!key) return;
        const cur = loadOpenGroups() || new Set();
        if (g.open) cur.add(key); else cur.delete(key);
        saveOpenGroups(cur);
      });
    });
  }

  /* ─── 3. Mobile drawer toggle ───────────────────────────────── */
  function wireMobileDrawer() {
    const sidebar = document.querySelector(".still-coll__sidebar");
    const facets = document.querySelector(".still-facets");
    const toggle = document.querySelector(".still-coll__filter-toggle");
    if (!sidebar || !facets || !toggle) return;

    function open() {
      facets.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    function close() {
      facets.classList.remove("is-open");
      document.body.style.overflow = "";
    }

    toggle.addEventListener("click", open);

    // Close on Escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && facets.classList.contains("is-open")) close();
    });

    // Close when user taps outside (on overlay)
    document.addEventListener("click", function (e) {
      if (!facets.classList.contains("is-open")) return;
      if (facets.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });

    // Add a sticky "Apply" button on mobile if it doesn't exist
    if (window.matchMedia("(max-width: 990px)").matches
        && !document.querySelector(".still-facets__mobile-apply")) {
      const applyBtn = document.createElement("button");
      applyBtn.className = "still-facets__mobile-apply";
      applyBtn.type = "button";
      applyBtn.textContent = "Apply filters";
      applyBtn.addEventListener("click", close);
      facets.parentNode.appendChild(applyBtn);
    }
  }

  /* ─── Bootstrap ─────────────────────────────────────────────── */
  function init() {
    wireSearchInputs();
    wireGroupPersistence();
    wireMobileDrawer();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
